import types from '../mutation-types';
import ContactNotesAPI from '../../api/contactNotes';
import camelcaseKeys from 'camelcase-keys';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

// BonBoZ: ghim len dau, roi den ghi chu moi nhat. Ca hai getter dung chung mot
// phep so sanh - de le nhau thi cung mot ghi chu nam khac cho o hai man hinh.
const byPinnedThenNewest = (a, b) => {
  const pinnedA = a.pinned_at || 0;
  const pinnedB = b.pinned_at || 0;
  if (Boolean(pinnedA) !== Boolean(pinnedB)) return pinnedB ? 1 : -1;
  return pinnedB - pinnedA || b.id - a.id;
};

export const getters = {
  getAllNotesByContact: _state => contactId => {
    return [...(_state.records[contactId] || [])].sort(byPinnedThenNewest);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  // Sap o client chu khong o server: danh sach nay khong phan trang nen day la
  // cho DUY NHAT quyet dinh thu tu, server sap kieu khac cung khong anh huong.
  getAllNotesByContactId: _state => contactId => {
    const records = [...(_state.records[contactId] || [])].sort(
      byPinnedThenNewest
    );
    return camelcaseKeys(records);
  },
};

export const actions = {
  async get({ commit }, { contactId }) {
    commit(types.SET_CONTACT_NOTES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ContactNotesAPI.get(contactId);
      commit(types.SET_CONTACT_NOTES, { contactId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_NOTES_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, { contactId, content }) {
    commit(types.SET_CONTACT_NOTES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await ContactNotesAPI.create(contactId, content);
      commit(types.ADD_CONTACT_NOTE, { contactId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_NOTES_UI_FLAG, { isCreating: false });
    }
  },

  // Sua noi dung, ghim hoac bo ghim - deu la mot lan PATCH. `payload` chi chua
  // thu that su doi: { content } hoac { pinned }.
  async update({ commit }, { contactId, noteId, ...payload }) {
    commit(types.SET_CONTACT_NOTES_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await ContactNotesAPI.update(contactId, noteId, payload);
      commit(types.EDIT_CONTACT_NOTE, { contactId, data });
    } finally {
      commit(types.SET_CONTACT_NOTES_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, { noteId, contactId }) {
    commit(types.SET_CONTACT_NOTES_UI_FLAG, { isDeleting: true });
    try {
      await ContactNotesAPI.delete(contactId, noteId);
      commit(types.DELETE_CONTACT_NOTE, { contactId, noteId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_NOTES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_NOTES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_CONTACT_NOTES]($state, { data, contactId }) {
    $state.records = {
      ...$state.records,
      [contactId]: data,
    };
  },
  [types.ADD_CONTACT_NOTE]($state, { data, contactId }) {
    const contactNotes = $state.records[contactId] || [];
    $state.records[contactId] = [...contactNotes, data];
  },
  [types.EDIT_CONTACT_NOTE]($state, { data, contactId }) {
    const contactNotes = $state.records[contactId] || [];
    $state.records[contactId] = contactNotes.map(note =>
      note.id === data.id ? data : note
    );
  },
  [types.DELETE_CONTACT_NOTE]($state, { noteId, contactId }) {
    const contactNotes = $state.records[contactId];
    const withoutDeletedNote = contactNotes.filter(note => note.id !== noteId);
    $state.records[contactId] = [...withoutDeletedNote];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
